import { DigitalEmployee, EmployeeCategory, Industry } from './types';

export const digitalEmployees: DigitalEmployee[] = [
  {
    id: '1',
    name: 'Alex',
    description: 'Technical specialist with expertise in software development and data analysis.',
    avatar: 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortRound&accessoriesType=Prescription02&hairColor=Black&facialHairType=BeardLight&facialHairColor=Black&clotheType=Hoodie&clotheColor=Gray01&eyeType=Happy&eyebrowType=DefaultNatural&mouthType=Smile&skinColor=Light',
    skills: ['JavaScript', 'Python', 'Data Analysis', 'Machine Learning'],
    hourlyRate: 85,
    availability: 'Weekdays, 9AM-5PM',
    category: 'Developer',
    industries: ['Finance', 'Education']
  },
  {
    id: '2',
    name: 'Sarah',
    description: 'Creative designer with a passion for user experience and visual communication.',
    avatar: 'https://avataaars.io/?avatarStyle=Circle&topType=LongHairStraight&accessoriesType=Blank&hairColor=BrownDark&facialHairType=Blank&clotheType=BlazerShirt&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light',
    skills: ['UI/UX Design', 'Graphic Design', 'Prototyping', 'User Research'],
    hourlyRate: 75,
    availability: 'Flexible, including weekends',
    category: 'Developer',
    industries: ['Real Estate', 'Hospitality']
  },
  {
    id: '3',
    name: 'Marcus',
    description: 'Business analyst with strong project management and communication skills.',
    avatar: 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairDreads01&accessoriesType=Blank&hairColor=Auburn&facialHairType=MoustacheFancy&facialHairColor=Auburn&clotheType=CollarSweater&clotheColor=Blue03&eyeType=Side&eyebrowType=RaisedExcited&mouthType=Tongue&skinColor=Brown',
    skills: ['Project Management', 'Data Analysis', 'Strategic Planning', 'Communication'],
    hourlyRate: 95,
    availability: 'Monday-Thursday, 8AM-6PM',
    category: 'PMO',
    industries: ['Finance', 'Transportation']
  },
  {
    id: '4',
    name: 'Elena',
    description: 'Marketing specialist with expertise in digital campaigns and social media strategy.',
    avatar: 'https://avataaars.io/?avatarStyle=Circle&topType=LongHairBob&accessoriesType=Blank&hairColor=Blonde&facialHairType=Blank&clotheType=GraphicShirt&clotheColor=PastelBlue&graphicType=Bat&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light',
    skills: ['Digital Marketing', 'Social Media', 'Content Creation', 'SEO'],
    hourlyRate: 80,
    availability: 'Weekdays, 10AM-7PM',
    category: 'Personal Assistant',
    industries: ['Hospitality', 'Real Estate']
  },
  {
    id: '5',
    name: 'Jordan',
    description: 'HR specialist with expertise in talent acquisition and employee relations.',
    avatar: 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairTheCaesar&accessoriesType=Round&hairColor=Black&facialHairType=BeardMedium&facialHairColor=Black&clotheType=ShirtCrewNeck&clotheColor=Blue03&eyeType=Happy&eyebrowType=RaisedExcited&mouthType=Smile&skinColor=Light',
    skills: ['Recruitment', 'Employee Relations', 'Performance Management', 'HR Policies'],
    hourlyRate: 90,
    availability: 'Weekdays, 8AM-4PM',
    category: 'HR',
    industries: ['Education', 'Finance']
  },
  {
    id: '6',
    name: 'Olivia',
    description: 'RFP specialist with expertise in proposal writing and bid management.',
    avatar: 'https://avataaars.io/?avatarStyle=Circle&topType=LongHairCurly&accessoriesType=Prescription02&hairColor=Red&facialHairType=Blank&clotheType=BlazerSweater&eyeType=Default&eyebrowType=Default&mouthType=Smile&skinColor=Pale',
    skills: ['Proposal Writing', 'Bid Management', 'Technical Writing', 'Research'],
    hourlyRate: 85,
    availability: 'Weekdays, 9AM-6PM',
    category: 'RFP Developer',
    industries: ['Transportation', 'Finance']
  },
  {
    id: '7',
    name: 'Michael',
    description: 'Full-stack developer with expertise in web and mobile application development.',
    avatar: 'https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortFlat&accessoriesType=Blank&hairColor=Brown&facialHairType=BeardLight&facialHairColor=Brown&clotheType=Hoodie&clotheColor=Gray02&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light',
    skills: ['React', 'Node.js', 'TypeScript', 'Mobile Development'],
    hourlyRate: 95,
    availability: 'Flexible, including weekends',
    category: 'Developer',
    industries: ['Education', 'Finance']
  }
];
